import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';

interface StyledLinkProps {
    to: string;
    children: React.ReactNode;
    external?: boolean; // Indicates whether it's an external link
}

const StyledLink: React.FC<StyledLinkProps> = ({ to, children, external = false }) => {
    if (external) {
        return (
            <Box
                component="a"
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    color: 'primary.main',
                    textDecoration: 'none',
                    '&:hover': {
                        color: 'secondary.main',
                        textDecoration: 'underline',
                    },
                }}
            >
                {children}
            </Box>
        );
    }

    return (
        <Box
            component={RouterLink}
            to={to}
            sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                    color: 'secondary.main',
                    textDecoration: 'underline',
                },
            }}
        >
            {children}
        </Box>
    );
};

export default StyledLink;
